import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <div className="mb-12 border-b border-neutral-200 pb-8">
        <div className="label-eyebrow mb-3">Legal</div>
        <h1 className="font-display font-medium text-4xl sm:text-5xl tracking-tight">Privacy Policy</h1>
        <div className="mt-4 inline-block border border-amber-300 bg-amber-50 text-amber-900 text-xs px-3 py-1.5 rounded-sm">
          PLACEHOLDER · Final text pending · v1.0
        </div>
      </div>

      <div className="text-[15px] leading-relaxed space-y-6">
        <p className="italic text-neutral-600 border-l-2 border-neutral-300 pl-4">
          This is a placeholder Privacy Policy. Replace the sections below with your final,
          attorney-reviewed policy before going live.
        </p>

        <Section title="1. What we collect">
          <p>Account details you give us (name, email, phone), things you type or upload (listing
          descriptions, photos, messages), and technical logs (IP address, browser type, timestamps for
          agreements and payments).</p>
        </Section>

        <Section title="2. How we use it">
          <p>To operate DenShare — creating your account, matching guests and hosts, processing payments
          through Stripe, sending transactional emails, preventing fraud, and complying with legal
          requests.</p>
        </Section>

        <Section title="3. Sharing">
          <p>We share the minimum information needed with our processors (Stripe for payments, Resend for
          email, Emergent for object storage), and only what a Host or Guest needs to complete a booking
          (name, first initial, message thread). We do not sell your data.</p>
        </Section>

        <Section title="4. Retention">
          <p>We keep accounts and their history while you use DenShare and for a reasonable period after
          you delete it, so we can honor legal, tax, and dispute obligations. Legal agreement records
          (IP and timestamp of each acceptance) are retained as long as required for enforceability.</p>
        </Section>

        <Section title="5. Your rights">
          <p>You can request a copy of your data, correct it, or delete your account by emailing us. Some
          records — completed bookings, tax records, legal agreements — may be retained where required.</p>
        </Section>

        <Section title="6. Contact">
          <p>Questions? Email <span className="underline">privacy@denshare.app</span>.</p>
        </Section>

        <div className="mt-14 pt-6 border-t border-neutral-200 flex items-center justify-between text-sm text-neutral-500">
          <span>Version 1.0 (placeholder)</span>
          <Link to="/terms" className="underline text-neutral-900">Terms of Service →</Link>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display font-medium text-xl tracking-tight mb-2">{title}</h2>
      <div className="space-y-2 text-neutral-700">{children}</div>
    </section>
  );
}
